import axios from 'axios';

// Get API URL from environment or use the shared backend route
const API_BASE_URL = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');

// Create axios instance with proper configuration
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to attach auth token if available
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle errors without forcing a guest login redirect
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
    }
    return Promise.reject(error);
  }
);

export const getApiUrl = (path) => `${API_BASE_URL}${path}`;

export const apiClient = {
  get: async (path) => {
    try {
      const response = await axiosInstance.get(path);
      return response;
    } catch (error) {
      console.error(`GET ${path} failed:`, error);
      throw error;
    }
  },

  post: async (path, data = {}) => {
    try {
      const response = await axiosInstance.post(path, data);
      return response;
    } catch (error) {
      console.error(`POST ${path} failed:`, error);
      throw error;
    }
  },

  put: async (path, data = {}) => {
    try {
      const response = await axiosInstance.put(path, data);
      return response;
    } catch (error) {
      console.error(`PUT ${path} failed:`, error);
      throw error;
    }
  },

  patch: async (path, data = {}) => {
    try {
      const response = await axiosInstance.patch(path, data);
      return response;
    } catch (error) {
      console.error(`PATCH ${path} failed:`, error);
      throw error;
    }
  },

  delete: async (path) => {
    try {
      const response = await axiosInstance.delete(path);
      return response;
    } catch (error) {
      console.error(`DELETE ${path} failed:`, error);
      throw error;
    }
  }
};

export default apiClient;